"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTestEnv = isTestEnv;
/**
 * Check that we are running tests for internal development we need to disable this check
 * @private
 * @returns { boolean } returns true when running with jest
 */
function isTestEnv() {
  return typeof process !== 'undefined' && (process.env.JEST_WORKER_ID !== undefined || process.env.VITEST_WORKER_ID !== undefined) && !globalThis.internalDevelopment;
}
//# sourceMappingURL=isTestEnv.js.map